import { Component } from "@angular/core";
import { CUSTOM_ATTRIBUTE_IMPORT_TYPES } from "./util/master-definition/master.definition.spreadsheet.util";

@Component({
    selector: "s25-ng-import-custom-attribute-types",
    host: { class: "import-custom-attribute-types" },
    template: `
        <details open>
            <summary>Custom attribute types</summary>
            <ul class="c-margin-left--single c-margin-top--half">
                @for (attrType of types; track attrType.code) {
                    <li>
                        <code>{{ attrType.code }}</code> {{ attrType.label }}
                    </li>
                }
            </ul>
        </details>
    `,
    styles: [
        `
            :host {
                display: block;
                margin-top: 0.5rem;
            }

            summary {
                cursor: pointer;
                font-weight: bold;
            }

            code {
                margin-inline-end: 0.35em;
            }
        `,
    ],
    standalone: true,
})
export class ImportCustomAttributeTypesComponent {
    readonly types = CUSTOM_ATTRIBUTE_IMPORT_TYPES;
}
